import React, { cloneElement, Children, memo, ReactElement } from 'react'
import { DragDropContext, Droppable, DroppableProvided, DropResult } from 'react-beautiful-dnd'
import Box, { IBoxProps as MuiBoxProps } from 'transfix-ui/core/Box'
import { brandColors } from 'transfix-ui/theme/colors'
import { IDraggableListItemProps } from './components/DraggableListItem'

export interface IDraggableListProps {
  /**
   * @example 'draggable-shipment-stops'
   */
  droppableId: string
  /**
   * @example <DraggableListItem />
   */
  children: ReactElement<IDraggableListItemProps>[]
  /**
   * Triggers when drag event ends
   */
  onDragEnd: (result: DropResult) => void
  BoxProps?: MuiBoxProps
  /**
   * @default false
   */
  isDisabled?: boolean
}

export const DraggableList = memo<IDraggableListProps>(
  ({ children, droppableId, isDisabled = false, onDragEnd, BoxProps = {} }) => {
    return (
      <Box bgcolor={brandColors.coolGray1} data-test='DraggableList' {...BoxProps}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId={droppableId} isDropDisabled={isDisabled}>
            {({ droppableProps, innerRef, placeholder }: DroppableProvided) => {
              return (
                <div ref={innerRef} {...droppableProps}>
                  {Children.map(children, (child: ReactElement) => cloneElement(child, {}))}
                  {placeholder}
                </div>
              )
            }}
          </Droppable>
        </DragDropContext>
      </Box>
    )
  }
)

export default DraggableList
